<template>
  <v-select
    :value="value"
    clearable
    :rules="rules"
    item-text="name"
    item-value="id"
    :readonly="readonly"
    :label="label"
    :error-messages="errorMessages"
    :items="months"
    v-bind="$attrs"
    v-on="$listeners"
  ></v-select>
</template>

<script>
import { generateMonths } from '@/modules/holidays/common/utils';

import { mapGetters } from 'vuex';
import { textLine } from '@/modules/_global/variables/rules';

export default {
  name: 'MonthSelect',

  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: () => []
    },
    rules: {
      type: Array,
      default: () => textLine
    }
  },

  data() {
    return {
      months: []
    };
  },

  computed: {
    ...mapGetters('localization', ['lang'])
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      this.months = generateMonths(this.lang);
    }
  }
};
</script>

<style scoped></style>
